<kanzi-ui-main-card
  title="{{ 'warehouses.title' | translate }}"
  description="{{ 'warehouses.description' | translate }}"
>
  <ng-template kTemplate="rightTopContent">
    <p-button
      label="{{ 'warehouses.actions.create' | translate }}"
      icon="pi pi-plus"
      (onClick)="onCreateWarehouse()"
      [disabled]="isLoading()"
    ></p-button>
  </ng-template>

  <!-- Búsqueda -->
  <div class="mb-4">
    <span class="p-input-icon-left p-input-icon-right w-full md:w-6">
      <i class="pi pi-search"></i>
      <input
        pInputText
        type="text"
        [value]="searchText()"
        (input)="onSearch($event)"
        placeholder="{{ 'warehouses.search.placeholder' | translate }}"
        class="w-full"
      />
      @if (searchText()) {
      <i class="pi pi-times cursor-pointer" (click)="onClearSearch()"></i>
      }
    </span>
  </div>

  <!-- Loading State -->
  @if (isLoading() && warehouses.length === 0) {
  <div class="grid grid-nogutter">
    @for (i of [1, 2, 3, 4, 5, 6]; track i) {
    <div class="col-12 sm:col-6 md:col-4 lg:col-3 p-2">
      <p-card>
        <p-skeleton width="100%" height="150px"></p-skeleton>
        <p-skeleton width="80%" height="20px" styleClass="mt-2"></p-skeleton>
        <p-skeleton width="60%" height="15px" styleClass="mt-2"></p-skeleton>
      </p-card>
    </div>
    }
  </div>
  }

  <!-- DataView -->
  @if (!isLoading() || warehouses.length > 0) {
  <p-dataView [value]="warehouses" layout="grid">
    <ng-template pTemplate="header">
      <div class="flex justify-content-between align-items-center">
        <span class="text-lg font-semibold">
          {{ totalRecords() }}
          {{ totalRecords() === 1 ? 'warehouse' : 'warehouses' }}
        </span>

        @if (isLoading()) {
        <i class="pi pi-spin pi-spinner text-primary"></i>
        }
      </div>
    </ng-template>

    <ng-template pTemplate="grid" let-warehouses>
      <div class="grid grid-nogutter">
        @for (warehouse of warehouses; track warehouse.id) {
        <div class="col-12 sm:col-6 md:col-4 lg:col-4 p-2">
          <p-card
            styleClass="h-full cursor-pointer hover:shadow-4 transition-all transition-duration-200"
            (click)="onViewWarehouse(warehouse)"
            (mouseenter)="onWarehouseHover(warehouse)"
          >
            <ng-template pTemplate="header">
              <div
                class="bg-primary-gradient p-3 flex align-items-center justify-content-between"
              >
                <div class="flex align-items-center gap-2">
                  <i class="pi pi-building text-white text-2xl"></i>
                  <div>
                    <p class="text-white font-bold text-lg m-0">
                      {{ warehouse.name }}
                    </p>
                    @if (warehouse.external_id) {
                    <p class="text-white-alpha-80 text-sm m-0">
                      {{ warehouse.external_id }}
                    </p>
                    }
                  </div>
                </div>
                <p-tag
                  value="{{
                    warehouse.type?.name || ('warehouses.noType' | translate)
                  }}"
                  severity="success"
                  styleClass="text-xs"
                ></p-tag>
              </div>
            </ng-template>

            <div class="flex flex-column gap-2">
              <!-- Información -->
              @if (warehouse.description) {
              <div class="text-sm text-color-secondary">
                <i class="pi pi-info-circle mr-1"></i>
                {{ warehouse.description }}
              </div>
              } @if (warehouse.created_by) {
              <div class="text-xs text-color-secondary">
                <i class="pi pi-user mr-1"></i>
                {{ 'warehouses.createdBy' | translate }}:
                {{ warehouse.created_by.username }}
              </div>
              } @if (warehouse.created) {
              <div class="text-xs text-color-secondary">
                <i class="pi pi-calendar mr-1"></i>
                {{ warehouse.created }}
              </div>
              }
            </div>

            <ng-template pTemplate="footer">
              <div class="flex justify-content-between align-items-center">
                <p-button
                  label="{{ 'warehouses.actions.view' | translate }}"
                  icon="pi pi-eye"
                  styleClass="p-button-text p-button-sm"
                  (onClick)="onViewWarehouse(warehouse)"
                ></p-button>

                <div class="flex gap-1">
                  <p-button
                    icon="pi pi-pencil"
                    styleClass="p-button-text p-button-sm"
                    [pTooltip]="'warehouses.actions.edit' | translate"
                    (onClick)="onEditWarehouse(warehouse, $event)"
                  ></p-button>

                  <p-button
                    icon="pi pi-trash"
                    styleClass="p-button-text p-button-sm p-button-danger"
                    [pTooltip]="'warehouses.actions.delete' | translate"
                    (onClick)="onDeleteWarehouse(warehouse, $event)"
                    [loading]="deleteMutation.isPending()"
                  ></p-button>
                </div>
              </div>
            </ng-template>
          </p-card>
        </div>
        }
      </div>
    </ng-template>

    <ng-template pTemplate="empty">
      <div class="text-center py-5">
        <i class="pi pi-building text-6xl text-color-secondary mb-3"></i>
        <p class="text-xl font-semibold text-color-secondary">
          {{ 'warehouses.empty.title' | translate }}
        </p>
        <p class="text-color-secondary">
          {{ 'warehouses.empty.message' | translate }}
        </p>
        <p-button
          label="{{ 'warehouses.actions.create' | translate }}"
          icon="pi pi-plus"
          (onClick)="onCreateWarehouse()"
          styleClass="mt-3"
        ></p-button>
      </div>
    </ng-template>
  </p-dataView>
  }
</kanzi-ui-main-card>

<!-- Confirm Dialog -->
<p-confirmDialog></p-confirmDialog>
